import { Stack, Typography } from "@mui/material";
import moment from "moment";


export default function InfoContabeis({ resposta }: InfoContabeisProps) {

    const { historico, conta_devedora, conta_credora, data_emissao } = resposta;

    return (
        <Stack>
            {data_emissao && (
                <Typography variant="caption" component="div" my={0.5}>
                    Data emissão: <b>{moment(data_emissao).format("DD/MM/YYYY")}</b>
                </Typography>
            )}
            <Typography variant="caption" component='div' my={0.5}>Histórico: <b>{historico.nome}</b></Typography>
            <Stack direction="row" spacing={1} my={0.5}>
                <Typography variant="caption" component='div' my={0.5}>Conta Devedora:</Typography>
                <Stack direction="column" spacing={0.1}>
                    <Typography variant="caption" component='div' my={0.5}><b>{conta_devedora.codigo_contabil} - {conta_devedora.nome}</b></Typography>
                    {
                        conta_devedora.centro_custo &&
                        <Typography component='div' color="text.secondary" my={0.5} fontSize={11}><b>{conta_devedora.centro_custo.id} - {conta_devedora.centro_custo.nome}</b></Typography>
                    }
                </Stack>
            </Stack>
            <Stack direction="row" spacing={1} my={0.5}>
                <Typography variant="caption" component='div' my={0.5}>Conta Credora:</Typography>
                <Stack direction="column" spacing={0.1}>
                    <Typography variant="caption" component='div' my={0.5}><b>{conta_credora.codigo_contabil} - {conta_credora.nome}</b></Typography>
                    {
                        conta_credora.centro_custo &&
                        <Typography component='div' color="text.secondary" my={0.5} fontSize={11}><b>{conta_credora.centro_custo.id} - {conta_credora.centro_custo.nome}</b></Typography>
                    }
                </Stack>
            </Stack>
        </Stack>
    )
}

interface InfoContabeisProps {
    resposta: IInformacoesContabeis
}

export interface IInformacoesContabeis {
    local_cobranca: ILocalCobranca;
    departamento: IDepartamento;
    historico: IHistorico;
    conta_devedora: IContaDevedora;
    conta_credora: IContaCredora;
    data_emissao?: string;
}


export interface ILocalCobranca {
    codigo: number;
    nome: string;
    endereco: string;
    cep: string;
    cidade: string;
    uf: string;
}

export interface IDepartamento {
    cooperativa_id: number;
    id: number;
    nome: string;
}

export interface IHistorico {
    id: string;
    nome: string;
}

export interface IContaDevedora {
    id: number;
    conta_contabil: string;
    conta_contabil_formatada: string;
    codigo_contabil: number;
    nome: string;
    natureza: string;
    sistema_xy: string | null;
    tipo: string;
    centro_custos: any | null;
    centro_custo?: ICentroCusto
}

export interface IContaCredora {
    id: number;
    conta_contabil: string;
    conta_contabil_formatada: string;
    codigo_contabil: number;
    nome: string;
    natureza: string;
    sistema_xy: string | null;
    tipo: string;
    centro_custos: any | null;
    centro_custo?: ICentroCusto
}

interface ICentroCusto {
    id: number;
    nome: string;
}

